import React, { useContext, useEffect } from "react";
import CommonContext from "../Context/context";
import { helperText } from "../Helper/helperFunctions";
import ReactHtmlParser from "react-html-parser";

const RefundPolicy = () => {
  const { cmsData } = useContext(CommonContext);
  const PrivacyData = cmsData?.find((element) => {
    return element?.page == "Cancellation/Refund Policy";
  });
  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);
  return (
    <>
      <section className="page-title">
        <div className="container">
          <div className="content-box">
            <div className="content-wrapper">
              <div className="title">
                <h1>Cancellation/Refund Policy</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="about-section about-inner-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {PrivacyData?.description
                ? ReactHtmlParser(PrivacyData?.description)
                : helperText}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RefundPolicy;
